import { Checklist } from 'src/pages/checklists/data/types/Checklist';
import { createController, createControllerEndpoint } from '../utils/api'
import { useGlobalProject } from 'src/utils/globals';
import { OperationResultPayload } from 'src/data/types/core';

const project = useGlobalProject() || { UniqueCode: '' };

export default createController('/api/v1/checklists/' + project.UniqueCode, {
    getChecklist: createControllerEndpoint<Checklist>('GET', '/{id}'),
    getAllChecklists: createControllerEndpoint<Array<Checklist>>('GET', '/'),

    createChecklist: createControllerEndpoint<{ id: number }>('POST', '/'),
    deleteChecklist: createControllerEndpoint<void>('DELETE', '/{id}'),

    saveDescriptor: createControllerEndpoint<OperationResultPayload>('PUT', '/{id}'),

    turnOn: createControllerEndpoint<OperationResultPayload>('POST', '/{id}/activation'),
    turnOff: createControllerEndpoint<OperationResultPayload>('DELETE', '/{id}/activation'),

    restartForUser: createControllerEndpoint<void>('POST', '/{id}/restart-for-user'),
    restartForGroup: createControllerEndpoint<void>('POST', '/{id}/restart-for-group'),
});
